// extracted by mini-css-extract-plugin
module.exports = {"header":"FaqDetail_header__l1AC5","title":"FaqDetail_title__V4jxf","text":"FaqDetail_text__9_bWS"};